import type { ExportName } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import type { CrmEnrichmentJobObject } from "../types/types";

export const ENRICHMENT_OBJECT_TO_EXPORT_NAME: Record<CrmEnrichmentJobObject, ExportName> = {
    company: "accounts",
    contact: "contacts",
    lead: "leads",
};
